import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyVariable} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import TreeNodeDropdownFramework from '../../../common/DropdownMenus/TreeNodeDropdownFramework';
import AlertDialog from '../../../common/AlertDialog';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-navigations/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import { AddNewButtonLayout, PageSaveButton, TableCheckBox } from '../../../common/Global/globalStyles.style';

let userDetails = getLocalStorageVariables();

class FrameworkDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader:false,

            frameworkIndex:{},
            detailFramworkIndex:{},
            oldDetailFrameworkIndex:{},

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            frameworkId:"",
            prevFrameworkId:"",
            nextFrameworkId:"",
            draggedNodeId:"",
            heading:"",
            treeRefreshKey:0,
            selectionMap: {},
            orderedSelectionIds: [],
            frameworkClauseArr:[]
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showFrameworkTreeDialog){
            this.setState({
                showLoader:false,
    
                frameworkIndex:{},
                detailFramworkIndex:{},
                oldDetailFrameworkIndex:{},


                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",
                frameworkId:"",
                prevFrameworkId:"",
                nextFrameworkId:"",
                selectionMap: {},
                orderedSelectionIds: [],
                frameworkClauseArr:this.props.frameworkClauseArr || [],
                frameworkType:this.props.frameworkType
            },()=>{
                // 1. Initialize state *from props* BEFORE loading the data tree
                this.initializeSelectionState();
                
                // 2. Load the tree data (which will use the new selectionMap)
                this.getIndexLevelFramework();

                // 3. Force re-render key to ensure TreeView mounts with correct state
                this.setState(prevState => ({ treeRefreshKey: prevState.treeRefreshKey + 1 }));
            })
        }
    }

    // Handle info alert dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    // Handles the node expanding event in the TreeViewComponent.
    handleNodeExpanding = async (args) => {
        const nodeData = args.nodeData;
        // When a node is expanded, this function checks if the node has children.
        if (nodeData.hasChildren) {
            // If it does, it calls the getChildFramework function to fetch the child framework data.
            this.getChildFramework(nodeData.id);
        }
    }

    // Handles node expanding event in the details framework tree, fetching child data if available.
    handleDetailsNodeExpanding = async (args) => {
        const nodeData = args.nodeData;
        if (nodeData.hasChildren) {
            this.getChildFramework(nodeData.id,true);
        }
    }

    // Updates tree data by recursively traversing the node list.
    updateTreeDataWithChildren = (list, frameworkClauseId, childNodes) => {
        return list.map(node => {
            if (node.frameworkClauseId == frameworkClauseId) {
                // Update the node's child nodes and set its expanded state to true.
                return { ...node, child: childNodes, expanded: true };
            }

            // If node has children, recursively update their data
            if (node.child && node.child.length > 0) {
                // Recursively call the updateTreeDataWithChildren function on the node's children
                const updatedChildren = this.updateTreeDataWithChildren(node.child, frameworkClauseId, childNodes);

                // Check if any child is expanded, then keep this node expanded
                const isAnyChildExpanded = updatedChildren.some(child => child.expanded);

                // Update the node's child nodes and set its expanded state based on its children's expanded state
                return {
                    ...node,
                    child: updatedChildren,
                    expanded: isAnyChildExpanded // Keep this node expanded if any child is expanded
                };
            }

            // Collapse other nodes.
            return { ...node, expanded: false };
        });
    };

    // Finds a node by frameworkClauseId in the tree structure.
    findNodeByFrameworkClauseId = (nodes, frameworkClauseId) => {
        for (let node of nodes) {
            // Check if the current node matches the frameworkClauseId
            if (node.frameworkClauseId == frameworkClauseId) {
                return node;
            }

            // If the node has children, recursively search the child nodes
            if (node.child && node.child.length > 0) {
                const result = this.findNodeByFrameworkClauseId(node.child, frameworkClauseId);
                if (result) {
                    return result;
                }
            }
        }

        return null; // If not found, return null
    };

    // Handles the previous and next navigation for the framework tree.
    handlePrevNext = (updatedTreeData, frameworkClauseId) => {
        // Find the node object corresponding to the frameworkClauseId.
        let frameworkObj = this.findNodeByFrameworkClauseId(updatedTreeData, frameworkClauseId);
        
        // Create an array of frameworkClauseIds for easy indexing.
        let frameWorkIdIndex = updatedTreeData.map(item => item.frameworkClauseId);
        // Find the index of the parent node in the frameWorkIdIndex array.
        let taskIdIndex = frameWorkIdIndex.indexOf(frameworkObj.parentId);
        
        // Initialize previous and next index variables.
        let prevIndex = -1;
        let nextIndex = -1;

        // If the parent node is found, calculate the previous and next indices.
        if(taskIdIndex > -1){
            // Calculate the previous index.
            prevIndex = taskIdIndex-1;
            // Calculate the next index, handling the edge case where it's the last node.
            nextIndex = taskIdIndex+1;
            if(nextIndex >= frameWorkIdIndex.length){
                nextIndex = -1;
            }
        }
        this.setState({
            oldDetailFrameworkIndex:updatedTreeData,
            prevFrameworkId:prevIndex > -1?frameWorkIdIndex[prevIndex]:"",
            nextFrameworkId:nextIndex > -1?frameWorkIdIndex[nextIndex]:"",
        })
    }

    // Handle next button
    nextFramework = () => {
        this.getChildFramework(this.state.nextFrameworkId,true);
    }

    // Handle Previous button
    prevFramework = () => {
        this.getChildFramework(this.state.prevFrameworkId,true);
    }

    // Recursively updates a tree data structure by adding a parentId to each node.
    addParentIdToTree = (nodes, rootParentId = null) => {
        return nodes.map(node => {
            const isRootLevel = node.clauselevel === 1; // Identify root level nodes
            const currentParentId = isRootLevel ? node.frameworkClauseId : rootParentId; // For root level, use its own ID as parentId
    
            // Update the current node with the correct parentId
            const updatedNode = {
                ...node,
                parentId: rootParentId ? rootParentId : node.frameworkClauseId // For root, parentId is itself, for children use passed rootParentId
            };
    
            // Recursively apply the same for children
            if (node.child && node.child.length > 0) {
                updatedNode.child = this.addParentIdToTree(node.child, currentParentId);
            }
    
            return updatedNode;
        });
    };

    // Finds a node by frameworkClauseId in a tree and returns it with its parents.
    findNodeWithParents = (nodes, frameworkClauseId) => {
        for (const item of nodes) {
            // Check if the current item has the matching frameworkClauseId
            if (item.frameworkClauseId == frameworkClauseId) {
                return [item];
            }
            // If the item has children, search within the child array
            if (item.hasChildren && item.child.length > 0) {
                const result = this.findNodeWithParents(item.child, frameworkClauseId);
                if (result) {
                    return [{
                        ...item,  // Copy the parent node properties
                        child: result,  // Include only the matched child
                    }]
                }
            }
        }
    }

    // Handles node expansion in the tree view.
    nodeExpanded = (args) =>{
        const updatedTreeData = this.state.frameworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: true };
            }
            return node;
        });
        this.setState({ frameworkIndex: updatedTreeData });
    }

    // Handles node collapse in the tree view.
    nodeCollapsed = (args) =>{
        const updatedTreeData = this.state.frameworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: false };
            }
            return node;
        });
        this.setState({ frameworkIndex: updatedTreeData });
    }

    // Handles node expansion in the tree view.
    nodeDetailExpanded = (args) =>{
        const updatedTreeData = this.state.detailFramworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: true };
            }
            return node;
        });
        this.setState({ detailFramworkIndex: updatedTreeData });
    }

    // Handles node collapse in the tree view.
    nodeDetailCollapsed = (args) =>{
        const updatedTreeData = this.state.detailFramworkIndex.map(node => {
            if (node.id === args.nodeData.id) {
                return { ...node, expanded: false };
            }
            return node;
        });
        this.setState({ detailFramworkIndex: updatedTreeData });
    }

    // Renders a clickable tree node for framework clauses.
    nodeTemplate = (frameworkObj) => {
        let clauseHeadingSplit = frameworkObj.text.split(":");
        let clauseName = clauseHeadingSplit[0] ? clauseHeadingSplit[0] : "";
        let heading = clauseHeadingSplit[1] ? clauseHeadingSplit[1] : "";
        let displayPlaceholder = `${clauseName}<p style="white-space:nowrap">&nbsp;:&nbsp;</p>${heading}`;
        
        return (
            <div className="dialog-tree-structure-sync" style={{ maxWidth: '100%', marginTop: 0 }} 
            onClick={() => this.getframeworkclause(!isEmptyVariable(frameworkObj.parentId)?frameworkObj.parentId:frameworkObj.frameworkClauseId)}>
                <p className='task-dangerouslysethtml inner-html d-flex' style={{ marginBottom: 4}} dangerouslySetInnerHTML={{__html: displayPlaceholder}}></p>
            </div>
        )
    }

    // Renders a tree structure node with a dropdown for framework actions, displaying an arrow based on expansion state.
    frameworkTree = (frameworkObj) => {
        const arrowIconClass = frameworkObj.expanded ? "arrow-down" : "arrow-right";
        const isCheckedFromMap = this.state.selectionMap[frameworkObj.frameworkClauseId] || false; 

        return <div className="dialog-tree-structure-sync mt-0">
        {
            !isEmptyVariable(frameworkObj) &&
                <div className="tree-node-sync">
                    <div className="tree-dropdown-layout-sync" style={{alignItems:'flex-start', marginTop:1}}>
                        <span className={`expand-arrow ${arrowIconClass}`}></span>
                        <TableCheckBox onClick={this.handleStopPropagation} themeSettings={this.props.themeSettings} >
                            <input 
                                type="checkbox"
                                name={frameworkObj.frameworkClauseId}
                                id={frameworkObj.frameworkClauseId}
                                onChange={this.handleCheckboxChange}
                                checked={isCheckedFromMap}
                            />
                            <label for={frameworkObj.frameworkClauseId} style={{marginLeft:2}}></label>
                        </TableCheckBox>
                        <TreeNodeDropdownFramework
                            placeholder={frameworkObj.text}
                            description={frameworkObj.description ? frameworkObj.description : ""}
                            dropdownArr={[]}
                            labelParam={"label"}
                            className="framework-tree-node"
                            onDropDownItemClick={() => {}}
                            handleOnClick={() => this.handleVersionClause(frameworkObj)}
                            dropdownId={frameworkObj}
                            // fontbold={frameworkObj.fontbold}
                            // paraMT={"3px"}
                            themeSettings={this.props.themeSettings}
                        />
                    </div>
                </div>
            }
        </div>
    }

    // 🚀 RESTORED/CORRECTED: Initializes the local selection state from the parent prop
    initializeSelectionState = () => {
        // frameworkClauseArr is the prop containing ALL selected clauses for persistence/order
        const { frameworkClauseArr, rootFrameworkId } = this.props;
        const newSelectionMap = {};
        const newOrderedIds = [];

        // 1. Filter existing selections to include ONLY those belonging to the current framework
        const currentFrameworkClauses = (frameworkClauseArr || [])
            .filter(clause => String(clause.frameworkId) === String(rootFrameworkId))
            .sort((a, b) => (a.frameworkClauseOrder || 0) - (b.frameworkClauseOrder || 0));

        // 2. Populate the map and ordered array based on existing data
        currentFrameworkClauses.forEach(clause => {
            const clauseId = String(clause.frameworkClauseId);
            newSelectionMap[clauseId] = true;
            newOrderedIds.push(clauseId);
        });

        // 3. Update the state immediately
        this.setState({
            selectionMap: newSelectionMap,
            orderedSelectionIds: newOrderedIds,
        });
    };

    getClauseDetail = (detail) => detail || '';

    // FrameworkDialog.js - Add this method within the class
    handleCheckboxChange = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let frameworkClauseId = String(e.target.name);

        const { oldDetailFrameworkIndex, frameworkClauseArr } = this.state;

        // 1. Get the full details required to construct the clause object
        const fullDetails = this.findClauseDetails(oldDetailFrameworkIndex, frameworkClauseId);
        
        // Create a mutable copy of the array from state
        let newFrameworkClauseArr = [...frameworkClauseArr];
        
        // Check if the clause is already in the array
        const existingIndex = newFrameworkClauseArr.findIndex(
            clause => String(clause.frameworkClauseId) === String(frameworkClauseId)
        );
        if (isChecked) {
            // ADD: If checked, add it to the array only if it's not already present
            if (existingIndex === -1) {
                const clauseToStore = {
                    frameworkClauseId: frameworkClauseId,
                    frameworkId: String(this.props.rootFrameworkId), // Get from props
                    frameworkClauseName: this.getClauseDetail(fullDetails?.clauseName) || '',
                    frameworkClauseHeading: this.getClauseDetail(fullDetails?.heading) || '',
                    frameworkClauseDescription: this.getClauseDetail(fullDetails?.description) || ''
                    // Order is naturally preserved by push operation
                };
                newFrameworkClauseArr.push(clauseToStore);
            }
        } else {
            // REMOVE: If unchecked, remove it from the array if present
            if (existingIndex !== -1) {
                newFrameworkClauseArr.splice(existingIndex, 1);
            }
        }
        
        // 2. Update local state with the new array and selection map for visual feedback
        this.setState(prevState => {
            // Update the selection map (for checkbox rendering)
            const newSelectionMap = {
                ...prevState.selectionMap,
                [frameworkClauseId]: isChecked
            };

            // Update the ordered IDs array (for sequence/order rendering)
            let newOrderedIds = [...prevState.orderedSelectionIds];
            const existingOrderedIndex = newOrderedIds.indexOf(frameworkClauseId);

            if (isChecked) {
                if (existingOrderedIndex === -1) {
                    newOrderedIds.push(frameworkClauseId);
                }
            } else {
                if (existingOrderedIndex !== -1) {
                    newOrderedIds.splice(existingOrderedIndex, 1);
                }
            }
            return {
                selectionMap: newSelectionMap,
                orderedSelectionIds: newOrderedIds, // Preserve selection order
                frameworkClauseArr: newFrameworkClauseArr || [], // <-- The key change: Update the stored data array
                treeRefreshKey: prevState.treeRefreshKey + 1
            };
        });
    };

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    // Closes the framework tree dialog and reloads the listing.
    handleFrameworkTreeClose = () => {
        this.props.handleFrameworkTreeDialogClose();
    }

    // Function to find a specific clause object (with name/heading) in the full tree structure
    findClauseDetails = (nodes, frameworkClauseId) => {
        for (const node of nodes) {
            if (String(node.frameworkClauseId) === String(frameworkClauseId)) {
                // Found the full clause object
                return node;
            }
            if (node.child && node.child.length > 0) {
                const foundInChild = this.findClauseDetails(node.child, frameworkClauseId);
                if (foundInChild) {
                    return foundInChild;
                }
            }
        }
        return null;
    };

    saveFrameworkClause = () => {
        this.props.handleFrameworkTreeDialogClose(this.state.frameworkClauseArr, true);
    }
    /************************API CALLS **************************/
    getIndexLevelFramework = () => {
        this.setState({
            showLoader:true,
        });
        let url = Constants.GetIndexLevelFramework;
        if(this.state.frameworkType === "Internal"){
            url = Constants.GetIndexLevelInternalFramework;
        }
        fetch(url,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkId:this.props.rootFrameworkId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.data.frameworkIndex;
                const { selectionMap } = this.state; // Use selectionMap here

                // Convert the object to an array of objects
                const frameworkIndex = temp.map(clause  => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: false,
                    child: [], // Empty for now; will be populated dynamically
                    isChecked: selectionMap[String(clause.frameworkClauseId)] || false, 
                }));

                this.setState({
                    frameworkIndex:frameworkIndex,
                    detailFramworkIndex:frameworkIndex,
                    oldDetailFrameworkIndex:frameworkIndex,
                    showLoader:false
                });
            }else{
                this.setState({
                    frameworkIndex:{},
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }

    getChildFramework = (frameworkClauseId,isDetailNode) => {
        fetch(Constants.GetChildFramework,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:frameworkClauseId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let childData = data.data;
                const { selectionMap } = this.state; // Use selectionMap here

                const childNodes = childData.map(clause => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: false,
                    child: [],
                    // Set isChecked based on existing selections
                    isChecked: selectionMap[String(clause.frameworkClauseId)] || false, // <--- NEW CHECK
                }));
                if(isDetailNode == true){
                    // Add child node inside oldDetailFrameworkIndex array
                    const updatedTreeData = this.updateTreeDataWithChildren(this.state.oldDetailFrameworkIndex, frameworkClauseId, childNodes);
                    
                    // display only selected parent and child node based on click of the right arrow icon
                    const frameworkIndex = this.findNodeWithParents(updatedTreeData, frameworkClauseId);
                    
                    // Add parentId to each child node.
                    const treeData = this.addParentIdToTree(updatedTreeData);
                    
                    // Handle Previous/Next Id
                    this.handlePrevNext(treeData, frameworkClauseId);
                    this.setState({ detailFramworkIndex: frameworkIndex });
                }else{
                    const updatedTreeData = this.updateTreeDataWithChildren(this.state.frameworkIndex, frameworkClauseId, childNodes);
                    const treeData = this.addParentIdToTree(updatedTreeData);
                    treeData.map(item => item.child.map(childItem => delete childItem.hasChildren))
                    this.setState({ frameworkIndex: treeData });
                }
            }else{
                this.setState({
                    showLoader: false,
                    showAlertDialogInfo: true,
                    alertDialogMessageInfo:data.responseMessage
                })
            }
        });
    }

    getframeworkclause = (frameworkClauseId) => {
        this.setState({
            showLoader:true,
        });

        fetch(Constants.GetFrameworkClause,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkClauseId:frameworkClauseId
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let temp = data.data;
                const nestedChild = temp.filter(item => item.clauselevel == 1).map(parent => {
                    // Find children of this parent clause
                    const child = temp.filter(child => child.parentClauseId == parent.frameworkClauseId)
                    .map(item => ({
                        ...item,
                        id: item.frameworkClauseId,
                        text: `${item.clauseName}: ${item.heading}`,
                        description: item.description,
                        hasChildren: item.hasChild === 'Y',
                        expanded: false,
                        child: []
                    }));
                    return {
                        ...parent,
                        child
                    };
                })
                // Convert the object to an array of objects
                nestedChild.map(clause  => ({
                    ...clause,
                    id: clause.frameworkClauseId,
                    text: `${clause.clauseName}: ${clause.heading}`,
                    description: clause.description,
                    hasChildren: clause.hasChild === 'Y',
                    expanded: true,
                    child: clause.child,
                }));
                // Add child node inside oldDetailFrameworkIndex array
                const updatedTreeData = this.updateTreeDataWithChildren(this.state.oldDetailFrameworkIndex, frameworkClauseId, nestedChild[0].child);
                // display only selected parent and child node based on click of the right arrow icon
                const frameworkIndex = this.findNodeWithParents(updatedTreeData, frameworkClauseId);

                // Add parentId to each child node.
                const treeData = this.addParentIdToTree(updatedTreeData);
                
                // Handle Previous/Next Id
                this.handlePrevNext(treeData, frameworkClauseId);

                this.setState({
                    detailFramworkIndex:frameworkIndex,
                    showLoader:false
                });
            }else{
                this.setState({
                    frameworkIndex:{},
                    showLoader:false,
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                });
            }
        });
    }

    /************************API CALLS END HERE**************************/

    render() {
        return(
            <div>
                <Modal className="show-framework-tree-dialog custom-dialog"
                show={this.props.showFrameworkTreeDialog} onHide={this.handleFrameworkTreeClose} backdrop="static">
                    <Modal.Header>
                        <TreeNodeDropdownFramework
                            placeholder={this.props.rootNode?.frameworkName}
                            dropdownArr={[]}
                            labelParam={"label"}
                            onDropDownItemClick={()=>{}}
                            className="framework-tree"
                            fontbold={true}
                            paraMT={"1.5px"}
                            themeSettings={this.props.themeSettings}
                            rootNode={true}
                        />
                        <button 
                            onClick={this.handleFrameworkTreeClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        { 
                            this.state.showLoader && 
                            <div class="loader"></div>
                        }
                        
                        <div className="row custom-row framework-tree-view">
                            <div className="col-md-3 custom-col theme-border-right" style={{minHeight:"400px"}}>
                                <p>Index</p>
                                <TreeViewComponent
                                    fields={{
                                        dataSource: this.state.frameworkIndex,
                                        id: 'id',
                                        text: 'text',
                                        hasChildren: 'hasChildren',
                                        expanded: 'expanded',
                                        child: 'child',
                                    }}
                                    nodeTemplate={this.nodeTemplate}
                                    nodeExpanded={this.nodeExpanded}
                                    nodeCollapsed={this.nodeCollapsed}
                                    nodeExpanding={this.handleNodeExpanding}
                                />
                            </div>
                            <div className="col-md-9 custom-col">
                                <div className="d-flex justify-content-end">
                                    {
                                        !isEmptyVariable(this.state.prevFrameworkId) &&
                                        <AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginLeft:10}}>
                                            <a onClick={this.prevFramework} href="javascript:void(0);">
                                                <span className="material-icons">arrow_back_ios</span>
                                                <p>Prev</p>
                                            </a>
                                        </AddNewButtonLayout>
                                    }
                                    {
                                        !isEmptyVariable(this.state.nextFrameworkId) &&
                                        <AddNewButtonLayout themeSettings={this.props.themeSettings} style={{marginLeft:10}}>
                                            <a onClick={this.nextFramework} href="javascript:void(0);">
                                                <p style={{marginRight:6,marginLeft:0}}>Next</p>
                                                <span className="material-icons">arrow_forward_ios</span>
                                            </a>
                                        </AddNewButtonLayout>
                                    }
                                </div>
                                <TreeViewComponent 
                                    key={this.state.treeRefreshKey}
                                    fields={{
                                        dataSource: this.state.detailFramworkIndex,
                                        id: 'id',
                                        text: 'text',
                                        description: 'description',
                                        hasChildren: 'hasChildren',
                                        expanded: 'expanded',
                                        child: 'child',
                                    }}
                                    cssClass={'custom-framework-tree-node'}
                                    nodeTemplate={this.frameworkTree}
                                    nodeExpanded = {this.nodeDetailExpanded}
                                    nodeCollapsed = {this.nodeDetailCollapsed}
                                    nodeExpanding={this.handleDetailsNodeExpanding}
                                />
                            </div>
                        </div>
                         <div className="row custom-row">
                            <div className="col-md-12 custom-col">
                                <div className="common-close-save m-b-20">
                                    <div className="common-close-save-col">
                                        <button
                                            onClick={this.props.handleFrameworkTreeDialogClose}
                                            type="button"
                                            className="common-close"
                                        >
                                            Cancel
                                        </button>
                                        <PageSaveButton
                                            themeSettings={this.props.themeSettings}
                                            onClick={()=>this.saveFrameworkClause()}
                                            type="button"
                                        >
                                            Submit
                                        </PageSaveButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <AlertDialog 
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL }
                    themeSettings={this.props.themeSettings}
                />
            </div>
        );
    }
}

export default FrameworkDialog;